import React from 'react';
import SignUpForm from '../../Features/SignUpForm/SignUpForm';
import Terms from '../../../../Features/Terms/Terms';
// import SocialLinks from '../../../../Features/SocialLinks/SocialLinks';
import SignUpStepProgressLayout from '../../Layout/SignUpStepProgressLayout';
import AuthBetweenLink from '../../../../Features/AuthBetweenLink/AuthBetweenLink';
import { useTranslation } from 'react-i18next';

function SignUpMainFormStep() {
  const { t } = useTranslation();
  return (
    <SignUpStepProgressLayout step={1}>
      <SignUpForm />
      <AuthBetweenLink title={t('signup.main.login1')} link={'/auth/login'} linkText={t('signup.main.login2')} />
      {/*<SocialLinks/>*/}
      <Terms />
    </SignUpStepProgressLayout>
  );
}

export default SignUpMainFormStep;
